// storefronts
export const STR_MUTATION_ID_UPDATE_STOREFRONT =
  "STR_MUTATION_ID_UPDATE_STOREFRONT";
// products
export const STR_MUTATION_UPDATE_PRODUCT = "STR_MUTATION_UPDATE_PRODUCT";
// cart
export const STR_MUTATION_ADD_TO_CART = "STR_MUTATION_ADD_TO_CART";
export const STR_MUTATION_REMOVE_FROM_CART = "STR_MUTATION_REMOVE_FROM_CART";
export const STR_MUTATION_SET_CART_ITEM_QUANTITY =
  "STR_MUTATION_SET_CART_ITEM_QUANTITY";
export const STR_MUTATION_UPDATE_ORDER = "STR_MUTATION_UPDATE_ORDER";
export const STR_MUTATION_RESET_CART_STATE = "STR_MUTATION_RESET_CART_STATE";
export const STR_MUTATION_RESET_ORDER_STATE = "STR_MUTATION_RESET_ORDER_STATE";
export const STR_MUTATION_RESET_INVENTORY_STATE =
  "STR_MUTATION_RESET_INVENTORY_STATE";
export const STR_MUTATION_SET_SHIPPING_ADDRESS_COUNTRY =
  "STR_MUTATION_SET_SHIPPING_ADDRESS_COUNTRY";
// meta
export const STR_MUTATION_SET_PARENT_PASSCODE =
  "STR_MUTATION_SET_PARENT_PASSCODE";
